import React from 'react';
import { SvgIcon } from 'seduo-ui';
const Example = () => (<section className="mb-9 card">
        <div className="card-body">
            <div className="icon-list row">
                <div className="icon-list__icon col-1">
                    <SvgIcon kind="GraduationCapOutline" className="icon icon-dark icon-moderate"/>
                </div>
                <div className="col-10">
                    <strong className="font-weight-medium text-title">Po vystudování zvládnete:</strong>
                    <div className="text-truncate-multiline text-truncate-multiline-3 text-secondary card__text-line--smaller">
                        Lorem ipsum dolor sit amet, consectetur adipisicing elit. Aspernatur dolor dolore explicabo quo
                        recusandae saepe soluta veniam! Alias blanditiis explicabo ipsam vero voluptatum. Eligendi eum
                        illum laboriosam libero quo! Inventore!
                    </div>
                </div>
            </div>
            <div className="icon-list row">
                <div className="icon-list__icon col-1">
                    <SvgIcon kind="Certificate" className="icon icon-dark icon-moderate"/>
                </div>
                <div className="col-10">
                    <strong className="font-weight-medium text-title">Získáte certifikát:</strong>
                    <p className="text-brand-dark card__text-line--smaller">Management 2: vedení středního týmu</p>
                </div>
            </div>
            <a href="#" className="btn btn-primary btn-large btn-block">
                <span className="mr-5">
                    <SvgIcon kind="Play" className="icon"/>
                </span>
                Začít studovat
            </a>
            <a href="#" className="btn btn-outline-primary btn-large btn-block">
                Přidat do plánu
            </a>
        </div>
        <div className="card-footer bg-white">
            <div className="icon-list row">
                <div className="icon-list__icon col-1">
                    <SvgIcon kind="StarOutline" className="icon icon-secondary mr-6"/>
                </div>
                <div className="col-10 pl-5">
                    <small className="text-secondary">Obsahuje výběr těch nejlepších kurzů</small>
                </div>
            </div>
            <div className="icon-list row">
                <div className="icon-list__icon col-1">
                    <SvgIcon kind="Notes" className="icon icon-secondary mr-6"/>
                </div>
                <div className="col-10 pl-5">
                    <small className="text-secondary">10 pracovních materiálů &middot; 5 kvízů</small>
                </div>
            </div>
            <div className="icon-list row">
                <div className="icon-list__icon col-1">
                    <SvgIcon kind="Sound" className="icon icon-secondary mr-6"/>
                </div>
                <div className="col-10 pl-5">
                    <small className="text-secondary">Všechny kurzy v programu jsou česky</small>
                </div>
            </div>
            <div className="icon-list row">
                <div className="icon-list__icon col-1">
                    <SvgIcon kind="Mobile" className="icon icon-secondary mr-6"/>
                </div>
                <div className="col-10 pl-5">
                    <small className="text-secondary">Studujte kdekoliv díky mobilní aplikaci</small>
                </div>
            </div>
        </div>
    </section>);
export default Example;
